import { render, staticRenderFns } from "./UserShow.vue?vue&type=template&id=6b528a00&scoped=true&"
import script from "./UserShow.vue?vue&type=script&lang=js&"
export * from "./UserShow.vue?vue&type=script&lang=js&"
import style0 from "./UserShow.vue?vue&type=style&index=0&id=6b528a00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b528a00",
  null
  
)

export default component.exports